import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=6d508edf&lang=scss"

const __exports__ = script;

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QToolbar,QImg,QToolbarTitle,QBtn,QMenu,QList,QItem,QItemSection});qInstall(script, 'directives', {ClosePopup});
